import {_SYSTEM_TITLES} from '../../../configuration/index.config';

export const PROJECT_DETAIL = JSON.stringify({
    name: '',
    description: '',
    tags: [],
    labels: [],
    attributes: []
});

export const PROJECT_DETAIL_INPUT = JSON.stringify({
    name: '',
    tags: '',
    labels: '',
    attributes: '',
    description: '',
    folder: ''
});
export const WARNING_POPUP = {
    default: {
        title: _SYSTEM_TITLES.errorModalDefault,
        subtitle: _SYSTEM_TITLES.errorModalDefaultSub,
        close: () => {},
        btnList: [
            {
                title: 'Cancel',
                className: 'btn-inner',
                onClick: () => {}
            },
            {
                title: 'Retry',
                className: 'btn-main',
                onClick: () => {}
            }],
        isActiveBtn: true
    },
    cancelTraining: {
        title: 'Cancel Training',
        subtitle: 'This training is in process. Are you sure you want to stop the process and cancel the training?',
        close: () => {},
        btnList: [
            {
                title: 'No, Go back',
                className: 'btn-inner',
                onClick: () => {}
            },
            {
                title: 'Confirm',
                className: 'btn-red',
                onClick: () => {}
            }],
        isActiveBtn: true
    }
};
export const LOADING_POPUP_VALUES = {
    createLoading: {
        title: `${_SYSTEM_TITLES.createTagging}`,
        subTitle: `${_SYSTEM_TITLES.subCreateTagging}`
    },
    trainingLoading: {
        title: `${_SYSTEM_TITLES.createTraining}`,
        subTitle: `${_SYSTEM_TITLES.subCreateTraining}`
    }
};

export const fakeData = (amount) => {
    const fakeDataArray:any = [];

    for (let i = 1; i < amount; i++) {
        fakeDataArray.push({name: `project_${i}`, id: `${i}`});
    }

    return fakeDataArray;
};

export const projectStatus = {
    regular: 'Regular',
    draft: 'Draft',
};
export const projectTypes = {
    regular: 'Regular',
    automatic: 'Automatic',
    shared: 'Shared'
};

